(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name                 : 'ReservationCancelTravel',
		confirm_before_submit: false,
		confirm_message      : '',
	};

	var $form;

	var _updateCancelAll,
	    _buildConfirmMessage;

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		$form = $(form.element);

		// Toggle new/existing reservation
		$form.find('.cancel-all-components').on('change', function change(e) {
			if ($(this).val() === '1') {
				$form.find('.cr-toggle-vendor').prop('checked', true);
			} else {
				$form.find('.cr-toggle-vendor').prop('checked', false);
			}

			$form.find('.cr-toggle-vendor').trigger('change');
		});

		// Toggle vendor logic
		$form.find('.cr-toggle-vendor').on('change', function change(e) {
			var $checkbox           = $(this),
			    $reservation_vendor = $('#reservation-vendor-' + $checkbox.data('reservation-vendor-id'));

			if ($checkbox.prop('checked')) {
				$reservation_vendor.find('.cr-vendor:not(".cr-checkbox.cr-additional-component")').prop('disabled', false);
				$reservation_vendor.find('.cr-checkbox').prop('checked', true);
				$reservation_vendor.find('.cr-hidden').val('1');
			} else {
				$reservation_vendor.find('.cr-hidden').val('0');
				$reservation_vendor.find('.cr-checkbox').prop('checked', false);
				$reservation_vendor.find('.cr-vendor').prop('disabled', true);
			}

			_updateCancelAll();
		});

		// Toggle all components for vendor logic
		$form.find('.cr-toggle-components').on('change', function change(e) {
			var $checkbox           = $(this),
			    $reservation_vendor = $('#reservation-vendor-' + $checkbox.data('reservation-vendor-id'));

			if ($checkbox.prop('checked')) {
				$reservation_vendor.find('.cr-penalty').prop('disabled', false);
				$reservation_vendor.find('.cr-component.cr-checkbox:not(".cr-required-component")').prop('disabled', true);
				$reservation_vendor.find('.cr-checkbox').prop('checked', true);
				$reservation_vendor.find('.cr-hidden').val('1');
				$reservation_vendor.find('.cr-do-not-submit').prop('disabled', false);
			} else {
				$reservation_vendor.find('.cr-hidden').val('0');
				$reservation_vendor.find('.cr-checkbox').prop('checked', false);
				$reservation_vendor.find('.cr-checkbox').prop('disabled', false);
				$reservation_vendor.find('.cr-penalty').prop('disabled', true);
				$reservation_vendor.find('.cr-do-not-submit').prop('disabled', true);
			}

			_updateCancelAll();
		});

		$form.find('.cr-component.cr-checkbox').on('change', function change(e) {
			var $checkbox           = $(this),
			    $reservation_vendor = $('#reservation-vendor-' + $checkbox.data('reservation-vendor-id')),
			    $penalty            = $checkbox.parent().parent().find('.cr-penalty');

			if ($checkbox.prop('checked')) {
				$penalty.prop('disabled', false);

				if ($checkbox.hasClass('cr-required-component')) {
					$reservation_vendor.find('.cr-penalty').prop('disabled', false);
					$reservation_vendor.find('.cr-component.cr-checkbox:not(".cr-required-component")').prop('disabled', true);
					$reservation_vendor.find('.cr-checkbox').prop('checked', true);
					$reservation_vendor.find('.cr-hidden').val('1');
					$reservation_vendor.find('.cr-do-not-submit').prop('disabled', false);
				}
				else if ($checkbox.hasClass('cr-additional-component')) {
					$(this).prev().val('1');
				}

				if ($reservation_vendor.find('.cr-component.cr-checkbox:checked').length === $reservation_vendor.find('.cr-component.cr-checkbox').length) {
					$reservation_vendor.find('.cr-toggle-components').prop('checked', true);
				}
			} else {
				$penalty.prop('disabled', true);

				if ($checkbox.hasClass('cr-required-component')) {
					$reservation_vendor.find('.cr-checkbox').prop('disabled', false);
					$reservation_vendor.find('.cr-do-not-submit').prop('disabled', true);
				}
				else if ($checkbox.hasClass('cr-additional-component')) {
					$(this).prev().val('0');
				}

				$reservation_vendor.find('.cr-toggle-components').prop('checked', false);
			}

			_updateCancelAll();
		});

		$form.find('.navitrip-cancellation-policies').on('click', function clicked(e) {
			var $self                 = $(this),
			    reservation_vendor_id = $self.data('reservation-vendor-id'),
			    hotel                 = $self.data('modal-title'),
			    modal_bod;

				event.preventDefault();

				$('.modal-body').html('<i class="' + Adzuki.FaIcon.getIconStyle('spinner') + ' fa-spin"></i>');

				Adzuki.Ajax.get('/Reservations/getNavitripCancellationPolicies/' + reservation_vendor_id)
				.then(function _loadIt(response) {
					var policies;
					if (response.error_code) {
						modal_bod = response.error_text;
					} else if (response.canceled === true) {
						modal_bod = 'Reservation already canceled';
					} else if (response.cancelable === false) {
						modal_bod = 'Reservation is not cancelable';
					} else {
						policies = response.policies;

						modal_bod = '<ul>';
						Object.keys(policies).forEach(function loop(key) {
							modal_bod += '<li>' + policies[key] + '</li>';
						});

						modal_bod += '</ul>';
					}

					$('.modal-body').html(modal_bod);
				});

				$('.modal-title').text('Cancellation Policies - ' + hotel);
				$('.modal').modal('show');
		});

		// Build confirm message if changed
		$form.find('.cr-do-not-submit').on('change', function change(e) {
			_buildConfirmMessage();
		});

		_buildConfirmMessage();
	};

	_updateCancelAll = function _updateCancelAll()
	{
		// this appears to break toggling between "no" and "yes" radio buttons for cancel all components
		// so commenting out
		// if ($form.find('input:checkbox:not(:checked)').length === 0) {
		// 	$('#reservationcanceltravel-cancel_all_components-0').prop('checked', false);
		// 	$('#reservationcanceltravel-cancel_all_components-0').parent().removeClass('active');
		// 	$('#reservationcanceltravel-cancel_all_components-1').prop('checked', true);
		// 	$('#reservationcanceltravel-cancel_all_components-1').parent().addClass('active');
		// } else {
		// 	$('#reservationcanceltravel-cancel_all_components-1').prop('checked', false);
		// 	$('#reservationcanceltravel-cancel_all_components-1').parent().removeClass('active');
		// 	$('#reservationcanceltravel-cancel_all_components-0').prop('checked', true);
		// 	$('#reservationcanceltravel-cancel_all_components-0').parent().addClass('active');
		// }

		_buildConfirmMessage();
	};

	_buildConfirmMessage = function _buildConfirmMessage()
	{
		var cancelling_component_count         = 0,
		    econnect_cruise_count              = 0,
		    econnect_cruise_dont_submit_count  = 0,
		    econnect_cruise_cancelling_count   = 0,
		    econnect_lodging_count             = 0,
		    econnect_lodging_dont_submit_count = 0,
		    econnect_lodging_cancelling_count  = 0,
		    econnect_car_count                 = 0,
		    econnect_car_dont_submit_count     = 0,
		    econnect_car_cancelling_count      = 0;

		// count of selected components being cancelled
		$('.cr-checkbox').each(function incrementCount() {
			if ($(this).prop('checked') === true) {
				cancelling_component_count++;
			}
		});

		// if this checkbox is there, it means it's an econnect component
		$('.cr-do-not-submit').each(function incrementCount() {
			if ($(this).prop('disabled') === false) {
				if ($(this).data('component-type') === 'cruise') {
					econnect_cruise_count++;
				} else if ($(this).data('component-type') === 'lodging') {
					econnect_lodging_count++;
				} else if ($(this).data('component-type') === 'car') {
					econnect_car_count++;
				}

				// agent has checked the option to not submit the cancellation request
				if ($(this).prop('checked') === true) {
					if ($(this).data('component-type') === 'cruise') {
						econnect_cruise_dont_submit_count++;
					} else if ($(this).data('component-type') === 'lodging') {
						econnect_lodging_dont_submit_count++;
					} else if ($(this).data('component-type') === 'car') {
						econnect_car_dont_submit_count++;
					}
				}
			}
		});

		if (econnect_cruise_count > 0) {
			econnect_cruise_cancelling_count = econnect_cruise_count - econnect_cruise_dont_submit_count;
		}

		if (econnect_lodging_count > 0) {
			econnect_lodging_cancelling_count = econnect_lodging_count - econnect_lodging_dont_submit_count;
		}

		if (econnect_car_count > 0) {
			econnect_car_cancelling_count = econnect_car_count - econnect_car_dont_submit_count;
		}

		if (cancelling_component_count > 0) {
			form.confirm_message = 'Selected components will be cancelled within CP Maxx.<br>';

			if (econnect_cruise_cancelling_count > 0) {
				form.confirm_message = form.confirm_message + econnect_cruise_cancelling_count + ' eCONNECT cruise booking' + (econnect_cruise_cancelling_count > 1 ? 's' : '') + ' WILL be cancelled with the cruise line.<br>';
			}

			if (econnect_lodging_cancelling_count > 0) {
				form.confirm_message = form.confirm_message + econnect_lodging_cancelling_count + ' eCONNECT lodging booking' + (econnect_lodging_cancelling_count > 1 ? 's' : '') + ' WILL be cancelled with the lodging vendor.<br>';
			}

			if (econnect_car_cancelling_count > 0) {
				form.confirm_message = form.confirm_message + econnect_car_cancelling_count + ' eCONNECT car rental booking' + (econnect_car_cancelling_count > 1 ? 's' : '') + ' WILL be cancelled with the car rental company.<br>';
			}

			form.confirm_message       = form.confirm_message + 'Do you wish to continue?';
			form.confirm_before_submit = true;
		} else {
			form.confirm_message       = '';
			form.confirm_before_submit = false;
		}
	};

}(jQuery, window.Adzuki || {}));
